// Dao Catering & Events animations for Shopify Dawn
(function () {
  if (window.daoCateringScriptLoaded) return;
  window.daoCateringScriptLoaded = true;

  function initPackageCarousel(root, reduceMotion) {
    var carousel = root.querySelector("[data-dao-package-carousel]");
    if (!carousel || carousel.dataset.daoPackageCarouselInit === "true") return;
    carousel.dataset.daoPackageCarouselInit = "true";

    var track = carousel.querySelector("[data-dao-package-track]");
    var cards = Array.prototype.slice.call(carousel.querySelectorAll("[data-dao-package-card]"));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll("[data-dao-package-dot]"));
    var prev = root.querySelector("[data-dao-package-prev]");
    var next = root.querySelector("[data-dao-package-next]");
    var pin = root.querySelector("[data-dao-package-pin]");
    var activeIndex = 0;
    var ticking = false;
    var scrollTicking = false;
    var isDragging = false;
    var didDrag = false;
    var startX = 0;
    var startScrollLeft = 0;
    var resizeTimer = null;
    var wheelSnapTimer = null;
    var programmaticScrollTimer = null;
    var isProgrammaticScroll = false;
    var lastWheelSnapAt = 0;
    var wheelCooldown = 550;
    var targetLefts = [];
    var metricsDirty = true;
    var pinnedState = {
      enabled: false,
      maxScroll: 0,
      sectionTop: 0,
      scrollDistance: 0
    };

    if (!track || !cards.length) return;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function getPageY() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function canUseScrollProgress() {
      if (reduceMotion || !pin || !window.matchMedia) return false;
      if (window.matchMedia("(max-width: 749px)").matches) return false;
      if (!window.matchMedia("(pointer: fine)").matches) return false;
      if (window.matchMedia("(hover: none)").matches) return false;
      return true;
    }

    function updateEdgeSpace() {
      var card = cards[activeIndex] || cards[0];
      var cardWidth = card ? card.offsetWidth : 0;
      var edgeSpace = Math.max(16, (track.clientWidth - cardWidth) / 2);
      track.style.setProperty("--dao-package-edge-space", edgeSpace.toFixed(2) + "px");
      return edgeSpace;
    }

    function markMetricsDirty() {
      metricsDirty = true;
    }

    function measureTargetLefts() {
      updateEdgeSpace();
      var maxScroll = getMaxScroll();
      targetLefts = cards.map(function (card) {
        return clamp(card.offsetLeft - ((track.clientWidth - card.offsetWidth) / 2), 0, maxScroll);
      });
      metricsDirty = false;
      return targetLefts;
    }

    function getTargetLeft(index) {
      var targetIndex = clamp(index, 0, cards.length - 1);
      if (metricsDirty || targetLefts.length !== cards.length) {
        measureTargetLefts();
      }
      return targetLefts[targetIndex] || 0;
    }

    function setActive(index) {
      activeIndex = clamp(index, 0, cards.length - 1);
      cards.forEach(function (card, cardIndex) {
        var offset = cardIndex - activeIndex;
        card.classList.toggle("is-active", offset === 0);
        card.classList.toggle("is-prev", offset === -1);
        card.classList.toggle("is-next", offset === 1);
        card.classList.toggle("is-far", Math.abs(offset) > 1);
        card.classList.toggle("is-before", offset < -1);
        card.classList.toggle("is-after", offset > 1);
      });
      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === activeIndex;
        dot.classList.toggle("is-active", isActive);
        if (isActive) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    }

    function lockProgrammaticScroll(index, targetLeft) {
      window.clearTimeout(programmaticScrollTimer);
      isProgrammaticScroll = true;
      track.classList.add("is-programmatic");

      programmaticScrollTimer = window.setTimeout(function () {
        if (typeof targetLeft === "number") {
          track.scrollLeft = targetLeft;
        }
        setActive(index);
        isProgrammaticScroll = false;
        track.classList.remove("is-programmatic");
      }, reduceMotion ? 0 : 640);
    }

    function updateActiveFromScroll(force) {
      ticking = false;
      var shouldForce = force === true;
      if (isProgrammaticScroll && !shouldForce) return;

      var closestIndex = 0;
      var closestDistance = Infinity;
      var currentLeft = track.scrollLeft;

      if (metricsDirty || targetLefts.length !== cards.length) {
        measureTargetLefts();
      }

      targetLefts.forEach(function (targetLeft, index) {
        var distance = Math.abs(targetLeft - currentLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      setActive(closestIndex);
    }

    function requestActiveUpdate(force) {
      var shouldForce = force === true;
      if (isProgrammaticScroll && !shouldForce) return;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateActiveFromScroll(shouldForce);
      });
    }

    function updatePinnedMetrics() {
      var shouldEnable = canUseScrollProgress() && getMaxScroll() > 8;

      if (!shouldEnable) {
        pinnedState.enabled = false;
        pinnedState.maxScroll = 0;
        pinnedState.sectionTop = 0;
        pinnedState.scrollDistance = 0;
        root.classList.remove("is-scroll-progress");
        root.style.removeProperty("min-height");
        return;
      }

      root.classList.add("is-scroll-progress");
      measureTargetLefts();

      pinnedState.maxScroll = getMaxScroll();
      var pinHeight = pin.offsetHeight || root.offsetHeight || 1;
      root.style.minHeight = Math.ceil(pinHeight + pinnedState.maxScroll) + "px";

      var rootRect = root.getBoundingClientRect();
      pinnedState.enabled = true;
      pinnedState.sectionTop = rootRect.top + getPageY();
      pinnedState.scrollDistance = Math.max(1, root.offsetHeight - pinHeight);
    }

    function syncPinnedScroll() {
      scrollTicking = false;
      if (!pinnedState.enabled) return;

      var progress = clamp((getPageY() - pinnedState.sectionTop) / pinnedState.scrollDistance, 0, 1);
      var nextLeft = progress * pinnedState.maxScroll;
      if (Math.abs(track.scrollLeft - nextLeft) > 0.5) {
        track.scrollLeft = nextLeft;
      }
      requestActiveUpdate();
    }

    function requestPinnedSync() {
      if (!pinnedState.enabled || scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(syncPinnedScroll);
    }

    function getPinnedTargetY(targetLeft) {
      updatePinnedMetrics();
      if (!pinnedState.enabled || pinnedState.maxScroll <= 0) return null;
      var progress = clamp(targetLeft / pinnedState.maxScroll, 0, 1);
      return pinnedState.sectionTop + (progress * pinnedState.scrollDistance);
    }

    function goToPackage(index, options) {
      var targetIndex = clamp(index, 0, cards.length - 1);
      var targetLeft = getTargetLeft(targetIndex);
      setActive(targetIndex);
      if (!(options && options.skipLock)) {
        lockProgrammaticScroll(targetIndex, targetLeft);
      }

      var behavior = (options && options.immediate) || reduceMotion ? "auto" : "smooth";

      if (pinnedState.enabled && !(options && options.forceTrack)) {
        var targetY = getPinnedTargetY(targetLeft);
        if (targetY !== null) {
          window.scrollTo({
            top: targetY,
            behavior: behavior
          });
          return;
        }
      }

      track.scrollTo({
        left: targetLeft,
        behavior: behavior
      });
    }

    function isPinnedWheelActive() {
      if (!pinnedState.enabled) return false;
      var y = getPageY();
      return y >= pinnedState.sectionTop - 2 && y <= pinnedState.sectionTop + pinnedState.scrollDistance + 2;
    }

    function normalizeWheelDelta(value, event) {
      if (event.deltaMode === 1) return value * 16;
      if (event.deltaMode === 2) return value * (window.innerHeight || document.documentElement.clientHeight || 800);
      return value;
    }

    function getWheelDirection(event) {
      var deltaY = normalizeWheelDelta(event.deltaY, event);
      var deltaX = normalizeWheelDelta(event.deltaX, event);
      if (Math.abs(deltaY) < Math.abs(deltaX)) return 0;
      if (Math.abs(deltaY) < 18) return 0;
      return deltaY > 0 ? 1 : -1;
    }

    function handleWheelSnap(event) {
      if (event.ctrlKey || !isPinnedWheelActive()) return;

      var direction = getWheelDirection(event);
      if (!direction) return;

      var currentIndex = activeIndex;
      var nextIndex = clamp(currentIndex + direction, 0, cards.length - 1);
      if (nextIndex === currentIndex) return;

      var now = Date.now();
      if (now - lastWheelSnapAt < wheelCooldown) return;

      event.preventDefault();
      lastWheelSnapAt = now;
      goToPackage(nextIndex);

      window.clearTimeout(wheelSnapTimer);
      wheelSnapTimer = window.setTimeout(function () {
        requestActiveUpdate();
      }, wheelCooldown);
    }

    if (prev) {
      prev.addEventListener("click", function () {
        goToPackage(activeIndex - 1);
      });
    }

    if (next) {
      next.addEventListener("click", function () {
        goToPackage(activeIndex + 1);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        goToPackage(index);
      });
    });

    track.addEventListener("scroll", requestActiveUpdate, { passive: true });
    window.addEventListener("scroll", requestPinnedSync, { passive: true });
    root.addEventListener("wheel", handleWheelSnap, { passive: false });

    function refreshLayout() {
      markMetricsDirty();
      measureTargetLefts();
      updatePinnedMetrics();
      if (pinnedState.enabled) {
        syncPinnedScroll();
      } else {
        goToPackage(activeIndex, { forceTrack: true, immediate: true, skipLock: true });
      }
      requestActiveUpdate();
    }

    window.addEventListener("resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refreshLayout, 120);
    });

    track.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "mouse") return;
      isDragging = true;
      didDrag = false;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      track.classList.add("is-dragging");
      if (track.setPointerCapture) track.setPointerCapture(event.pointerId);
    });

    track.addEventListener("pointermove", function (event) {
      if (!isDragging) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 5) didDrag = true;
      track.scrollLeft = startScrollLeft - delta;
    });

    function stopDrag(event) {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove("is-dragging");
      if (event && track.hasPointerCapture && track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }
      updateActiveFromScroll(true);
      window.setTimeout(function () {
        goToPackage(activeIndex);
      }, 90);
      window.setTimeout(function () {
        didDrag = false;
      }, 80);
    }

    track.addEventListener("pointerup", stopDrag);
    track.addEventListener("pointercancel", stopDrag);
    track.addEventListener("mouseleave", stopDrag);

    cards.forEach(function (card) {
      var image = card.querySelector("img");
      if (image && !image.complete) {
        image.addEventListener("load", refreshLayout, { once: true });
      }
    });

    updateEdgeSpace();
    setActive(0);
    updatePinnedMetrics();
    if (pinnedState.enabled) {
      syncPinnedScroll();
    }
    requestActiveUpdate();
    window.setTimeout(refreshLayout, 250);
  }

  function initWhatsAppEnquiry(root) {
    var form = root.querySelector("[data-dao-whatsapp-enquiry]");
    if (!form || form.dataset.daoWhatsAppInit === "true") return;
    form.dataset.daoWhatsAppInit = "true";

    var whatsappNumber = form.dataset.daoWhatsappNumber;
    var status = form.querySelector("[data-dao-whatsapp-status]");
    var statusTimer = null;

    function getValue(name) {
      var field = form.elements[name];
      return field ? field.value.trim() : "";
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      if (!form.reportValidity()) return;

      var message = [
        "DAO Catering & Events Enquiry",
        "",
        "Name: " + getValue("name"),
        "Email: " + getValue("email"),
        "Event / Company / Occasion Name: " + getValue("event_name"),
        "Event Date: " + getValue("event_date"),
        "Event Time: " + getValue("event_time"),
        "Event Venue: " + getValue("event_venue"),
        "No. of Pax: " + getValue("pax"),
        "Dessert / Package Interested In: " + getValue("package_interest"),
        "Message: " + getValue("message")
      ].join("\n");
      var whatsappUrl = "https://wa.me/" + whatsappNumber + "?text=" + encodeURIComponent(message);

      if (status) {
        status.hidden = false;
        window.clearTimeout(statusTimer);
        statusTimer = window.setTimeout(function () {
          status.hidden = true;
        }, 2000);
      }

      var whatsappWindow = window.open(whatsappUrl, "_blank");
      if (whatsappWindow) {
        whatsappWindow.opener = null;
      } else {
        window.location.href = whatsappUrl;
      }
    });
  }

  function initDaoCatering(root) {
    if (!root || root.dataset.daoCateringInit === "true") return;
    root.dataset.daoCateringInit = "true";

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var revealEls = root.querySelectorAll(".dao-reveal");
    if (!reduceMotion && "IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });
      revealEls.forEach(function (el) { observer.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add("is-visible"); });
    }

    initPackageCarousel(root, reduceMotion);
    initWhatsAppEnquiry(root);

    var heroVisuals = root.querySelectorAll("[data-dao-parallax]");
    function updateParallax() {
      if (reduceMotion) return;
      heroVisuals.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var progress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - vh / 2) / (vh / 2)));
        var y = progress * -38;
        el.style.transform = "translateY(" + y.toFixed(2) + "px)";
      });
    }

    var counters = root.querySelectorAll("[data-count-to]");
    if ("IntersectionObserver" in window) {
      var countObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.dataset.countDone === "true") return;
          el.dataset.countDone = "true";
          var target = parseInt(el.dataset.countTo || "0", 10);
          var duration = parseInt(el.dataset.countDuration || "1800", 10);
          if (reduceMotion) {
            el.textContent = target.toLocaleString();
            return;
          }
          var start = performance.now();
          function tick(now) {
            var p = Math.min(1, (now - start) / duration);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * eased).toLocaleString();
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
          countObserver.unobserve(el);
        });
      }, { threshold: 0.35 });
      counters.forEach(function (el) { countObserver.observe(el); });
    } else {
      counters.forEach(function (el) { el.textContent = parseInt(el.dataset.countTo || "0", 10).toLocaleString(); });
    }

    if (heroVisuals.length) {
      window.addEventListener("scroll", updateParallax, { passive: true });
      window.addEventListener("resize", updateParallax);
      updateParallax();
    }
  }

  function boot() {
    document.querySelectorAll(".dao-catering-page").forEach(initDaoCatering);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event && event.target) {
      event.target.querySelectorAll(".dao-catering-page").forEach(initDaoCatering);
      if (event.target.classList && event.target.classList.contains("dao-catering-page")) initDaoCatering(event.target);
    }
  });
})();
